module.exports = __webpack_public_path__ + "static/media/dataQuality.9c9878b9.svg";